import { Spinner } from '#assets/Spinner.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

export function LoadingSpinner({ size = 48 }) {
  return (
    <CenteredLayout preventNotifications={true}>
      <Spinner size={size} />
    </CenteredLayout>
  );
}
